import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ROUTE_NAMES, RouterService } from '@go-modules/services/router/router.service';
import { GoToastStatusType } from '@go-modules/enums/go-toast-status-type';
import { NgxGoToastService } from '@go-modules/services/go-toast/go-toast.service';

export interface TrialSuccessDialogData {
	folder_id?: string;
}

@Component({
	selector: 'app-ai-trial-success-dialog',
	templateUrl: './ai-trial-success-dialog.component.html',
	styleUrls: ['./ai-trial-success-dialog.component.scss'],
	standalone: false
})
export class AiTrialSuccessDialogComponent {
	public constructor (
		public dialogRef: MatDialogRef<AiTrialSuccessDialogComponent>,
		private ngxGoToastService: NgxGoToastService,
		@Inject(MAT_DIALOG_DATA) public data: TrialSuccessDialogData,
		private routerService: RouterService
	) {
		this.dialogRef.afterClosed().subscribe(() => this.showToast(this.data.folder_id));
	}

	public close () {
		this.dialogRef.close();
	}

	private showToast (folder_id: string) {
		this.ngxGoToastService.createToast({
			type: GoToastStatusType.SUCCESS,
			message: 'ai-trial-success-dialog_toast',
			actionLink:{
				title: 'ai-trial-success-dialog_action_link',
				action: () => this.routerService.navigateTo(ROUTE_NAMES.DASHBOARD_FOLDER_VIEW, {folder_id})
			}
		});
	}
}
